import Statistics from '../components/Statistics/StatisticsList'
import Analytics from '../components/Statistics/Analytics'
import Sets from '../components/Statistics/Sets'
import Constructor from '../components/Constructor/Constructor'
import Constructor2 from '../components/Constructor/Constructor2'
import Access from '../components/Constructor/Access'
import Filters from '../components/Constructor/Filters'

const routes = [
  {
    path: '',
    name: 'analytics.index',
    component: Statistics
  },
  {
    path: 'admin',
    name: 'analytics.admin',
    component: Analytics
  },
  {
    path: 'sets',
    name: 'analytics.sets',
    component: Sets
  },
  {
    path: 'constructor',
    name: 'analytics.constructor',
    component: Constructor
  },
  {
    path: 'constructor2',
    name: 'analytics.constructor2',
    component: Constructor2
  },
  {
    path: 'access',
    name: 'analytics.access',
    component: Access
  },
  {
    path: 'filter',
    name: 'analytics.filter',
    component: Filters
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/analytics/router/routes.js